import type { ReactNode } from 'react'

import { SpreadsheetBackground } from '@/components'

interface TrialPageFrameProps {
  headerAction?: ReactNode
  children: ReactNode
}

export const TrialPageFrame = ({
  headerAction,
  children,
}: TrialPageFrameProps) => (
  <div className="relative flex min-h-screen overflow-hidden bg-background px-4 py-8 sm:px-8 lg:px-16">
    <SpreadsheetBackground />
    <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col gap-8">
      <header className="flex items-center justify-between">
        <img src="/logo.svg" alt="CounselPro" className="h-8 w-auto" />
        {headerAction}
      </header>
      {children}
    </div>
  </div>
)
